import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown, FaCheck } from "react-icons/fa";
import "./styles.scss";

const ROLES = [
  { value: "ADMIN", label: "Admin" },
  { value: "PUBLISHER", label: "Publisher" },
  { value: "CUSTOMER", label: "Customer" },
];

const RolesFilter = ({ selectedRoles = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleRole = (role) => {
    const newRoles = selectedRoles.includes(role)
      ? selectedRoles.filter((r) => r !== role)
      : [...selectedRoles, role];
    onChange(newRoles);
  };

  const getDisplayText = () => {
    if (selectedRoles.length === 0) return "All Roles";
    if (selectedRoles.length === 1) {
      const role = ROLES.find((r) => r.value === selectedRoles[0]);
      return role ? role.label : selectedRoles[0];
    }
    return `${selectedRoles.length} Roles`;
  };

  return (
    <div className="roles-filter-wrapper" ref={dropdownRef}>
      <button
        className={`roles-filter-button ${isOpen ? "open" : ""} ${selectedRoles.length > 0 ? "has-selection" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span>{getDisplayText()}</span>
        <FaChevronDown className={`roles-filter-arrow ${isOpen ? "rotated" : ""}`} />
      </button>
      {isOpen && (
        <div className="roles-filter-dropdown">
          {ROLES.map((role) => (
            <div
              key={role.value}
              className={`roles-filter-option ${selectedRoles.includes(role.value) ? "selected" : ""}`}
              onClick={() => handleToggleRole(role.value)}
            >
              <div className="roles-filter-checkbox">
                {selectedRoles.includes(role.value) && <FaCheck />}
              </div>
              <span>{role.label}</span>
            </div>
          ))}
          {selectedRoles.length > 0 && (
            <div className="roles-filter-clear" onClick={() => onChange([])}>
              Clear all
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RolesFilter;
